// Opções de intervalo de tempo predefinidas
export const TIME_RANGES = [
  { label: "1h", value: 60 * 60 * 1000, type: "minutes" },
  { label: "3h", value: 3 * 60 * 60 * 1000, type: "hours" },
  { label: "12h", value: 12 * 60 * 60 * 1000, type: "hours" },
  { label: "24h", value: 24 * 60 * 60 * 1000, type: "day" },
  { label: "3d", value: 3 * 24 * 60 * 60 * 1000, type: "days" },
  { label: "7d", value: 7 * 24 * 60 * 60 * 1000, type: "week" },
  { label: "30d", value: 30 * 24 * 60 * 60 * 1000, type: "month" },
  { label: "90d", value: 90 * 24 * 60 * 60 * 1000, type: "3months" },
  { label: "1y", value: 365 * 24 * 60 * 60 * 1000, type: "year" },
  { label: "3y", value: 3 * 365 * 24 * 60 * 60 * 1000, type: "3years" },
  { label: "ALL", value: "all", type: "all" },
  { label: "Custom", value: "custom", type: "custom" },
];

// Tipos
export interface TimeRange {
  label: string;
  value: number | string;
  type?: string;
}
